/* tslint:disable */
/* eslint-disable */
/**
 * Marketplace Api
 * Marketplace Api description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: develop@taykus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { IntegrationsLoginRequest } from '../models';
// @ts-ignore
import { IntegrationsLoginResponse } from '../models';
// @ts-ignore
import { Token } from '../models';
/**
 * IntegrationsApi - axios parameter creator
 * @export
 */
export const IntegrationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Start customer login flow
         * @param {string} xAPIKEY The API key
         * @param {IntegrationsLoginRequest} integrationsLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (xAPIKEY: string, integrationsLoginRequest: IntegrationsLoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xAPIKEY' is not null or undefined
            assertParamExists('login', 'xAPIKEY', xAPIKEY)
            // verify required parameter 'integrationsLoginRequest' is not null or undefined
            assertParamExists('login', 'integrationsLoginRequest', integrationsLoginRequest)
            const localVarPath = `/api/v2/integrations/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xAPIKEY !== undefined && xAPIKEY !== null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationsLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify token for customer login
         * @param {string} token The token received to finalize registration process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyToken: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('verifyToken', 'token', token)
            const localVarPath = `/api/v2/integrations/login/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationsApi - functional programming interface
 * @export
 */
export const IntegrationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Start customer login flow
         * @param {string} xAPIKEY The API key
         * @param {IntegrationsLoginRequest} integrationsLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(xAPIKEY: string, integrationsLoginRequest: IntegrationsLoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationsLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(xAPIKEY, integrationsLoginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify token for customer login
         * @param {string} token The token received to finalize registration process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyToken(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyToken(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IntegrationsApi - factory interface
 * @export
 */
export const IntegrationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Start customer login flow
         * @param {string} xAPIKEY The API key
         * @param {IntegrationsLoginRequest} integrationsLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(xAPIKEY: string, integrationsLoginRequest: IntegrationsLoginRequest, options?: any): AxiosPromise<IntegrationsLoginResponse> {
            return localVarFp.login(xAPIKEY, integrationsLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify token for customer login
         * @param {string} token The token received to finalize registration process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyToken(token: string, options?: any): AxiosPromise<Token> {
            return localVarFp.verifyToken(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationsApi - object-oriented interface
 * @export
 * @class IntegrationsApi
 * @extends {BaseAPI}
 */
export class IntegrationsApi extends BaseAPI {
    /**
     * 
     * @summary Start customer login flow
     * @param {string} xAPIKEY The API key
     * @param {IntegrationsLoginRequest} integrationsLoginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public login(xAPIKEY: string, integrationsLoginRequest: IntegrationsLoginRequest, options?: AxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).login(xAPIKEY, integrationsLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify token for customer login
     * @param {string} token The token received to finalize registration process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public verifyToken(token: string, options?: AxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).verifyToken(token, options).then((request) => request(this.axios, this.basePath));
    }
}
